var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"component"}},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"welcome-message"},[_vm._v(_vm._s(_vm.$t('welcome')))]),_vm._v(" "),_c('span',{staticClass:"company"},[_vm._v("falcon")]),_vm._v(" "),_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.username))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e985d36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = null
// module chunks = 